export default __webpack_public_path__ + "static/media/br-bannermobile.24df6fad.png";